module.exports = __webpack_public_path__ + "img/header.e052eaef.jpg";